import { render, staticRenderFns } from "./MedicalInfo.vue?vue&type=template&id=6eca58df&scoped=true&"
import script from "./MedicalInfo.vue?vue&type=script&lang=js&"
export * from "./MedicalInfo.vue?vue&type=script&lang=js&"
import style0 from "./MedicalInfo.vue?vue&type=style&index=0&id=6eca58df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca58df",
  null
  
)

export default component.exports